import { store } from 'store';
import { Pet, PetSize, PetType, PetTypeId, PetTypeIds } from 'types/Pet';

export const getPetSizeByWeight = (
    weight: number,
    petType: PetTypeId,
    orderedSizes: Array<PetSize>
): PetSize | null => {
    if (petType === PetTypeIds.CAT) {
        return {
            id: 'small',
            name: 'Small',
            description: 'Small',
            minWeight: null,
            maxWeight: null
        };
    }

    if (petType === PetTypeIds.EXOTIC) {
        return {
            id: 'medium',
            name: 'Medium',
            description: 'Medium',
            minWeight: null,
            maxWeight: null
        };
    }

    let size = orderedSizes.find(
        size =>
            (size.minWeight === null || weight >= size.minWeight) &&
            (size.maxWeight === null || weight <= size.maxWeight)
    );

    if (size === undefined && orderedSizes.length > 0) {
        const [firstSize] = orderedSizes;
        const [lastSize] = orderedSizes.reverse();

        if (firstSize.minWeight === null || weight < firstSize.minWeight) {
            size = firstSize;
        }

        if (lastSize.minWeight === null || weight > lastSize.minWeight) {
            size = lastSize;
        }
    }

    return size ?? null;
};

export const getPetBreedName = (petType: PetType, breedId: string | number): string => {
    const masterData = store.getState().masterData.data;
    const petBreed = masterData.petBreeds.find(
        breed => breed.id === breedId && breed.filter === petType.id
    );

    if (!petBreed) return '';

    return petBreed.name;
};

export const petsMatch = (pet1: Pet, pet2: Pet) => {
    const namesMatch = pet1.name.toLowerCase() === pet2.name.toLowerCase();
    const typesMatch = pet1.type.id === pet2.type.id;
    const breedsMatch = pet1.breed && pet2.breed ? pet1.breed.id === pet2.breed.id : true;

    return namesMatch && typesMatch && breedsMatch;
};
